/*
 * Copyright (c) 2015-2018, IGN France.
 * Copyright (c) 2018-2026, Giro3D team.
 * SPDX-License-Identifier: MIT
 */

export const DEFAULT_ENABLE_TERRAIN = true;
export const DEFAULT_ENABLE_STITCHING = true;
/**
 * The default number of segments in a map's tile.
 */
export const DEFAULT_MAP_SEGMENTS = 32;

/**
 * Options for geometric terrain rendering.
 */